//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import swipeout from "vux-comp/swipeout/swipeout";
import swipeoutItem from "vux-comp/swipeout/swipeout-item";
import swipeoutButton from "vux-comp/swipeout/swipeout-button";
import payMethod from "@/components/Repay/PayMethod";
import bankInfo from "@/components/BankInfo";

export default {
    name: "choose-card",
    components: {
        swipeout,
        swipeoutItem,
        swipeoutButton,
        payMethod,
        bankInfo,
    },
    data() {
        return {
            accountId: "",
        };
    },
    created() {
        if (this.payMethods.includes("wechat")) {
            this.sendRecord("614", this.isVip ? 1 : 0);
        }
    },
    props: {
        choosedCard: {},
        bankList: {},
        payMethod: {},
        payMethods: {},
        isVip: {},
        multiCard: {},
        repayAmount: {},
        isCardSupport: {
            type: Boolean,
            default: true,
        },
        isRepayPage: {
            type: Boolean,
            default: true,
        },
        aliPayTags: {},
        showRepayLimitTips: {
            type: Boolean,
            default: true,
        }
    },
    computed: {
        validBankList() {
            if (this.bankList && this.bankList.length) {
                return this.bankList.filter((item) => {

                    if (item.isSplit === 1) {
                        return true;
                    } else if (item.singleLimit) {
                        return +item.singleLimit >= +this.repayAmount;
                    }

                    return true;
                })
            }
            return [];
        },
        inValidBankList() {
            if (this.bankList && this.bankList.length) {
                return this.bankList.filter((item) => {
                    if (item.isSplit !== 1 && item.singleLimit) {
                        return +item.singleLimit < +this.repayAmount;
                    }
                    return false;
                })
            }
            return [];
        },
    },
    methods: {
        btnClick() {
            if (this.multiCard) {
                this.$emit("add-card");
            } else {
                this.$emit("change-card");
            }
        },
        chooseCard(bankInfo) {
            this.$emit("choose-method", { type: "card", bankInfo });
        },
        deleteCard(userBankAccountId) {
            this.$emit("delete-card", userBankAccountId);
        },
    },
};
